import { Helmet } from 'react-helmet-async';
// import MainSection from '../components/hrm/mainSection/MainSection';
import MainSection from '@/components/MainSection';
import { useTranslation } from 'react-i18next';
import CrmDetails from '../components/crm/CrmDetails';
import Crm1 from '@/assets/svg/products/Crm1';

export default function CrmPage() {
    const { t } = useTranslation();

    return (
        <>
            <Helmet>
                <title>Crm</title>
                <meta name="description" content="Welcome to our hrm page. Explore our hrm and services." />
                <link rel="canonical" href="/crm" />
            </Helmet>
            <div className="w-full mb-[100px] relative overflow-hidden ">
                <MainSection
                    title={t('products.1.title')}
                    description={t('home.products.crmDescription')}
                    icon={<Crm1 />}
                />
            </div>

            <CrmDetails />
        </>
    );
}
